"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _cookiesJs = _interopRequireDefault(require("cookies-js"));

var _logger = require("js-utils/logger");

var _withFollowGDPRModalControls = _interopRequireDefault(require("../HOC/withFollowGDPRModalControls"));

var _destinationUtils = require("@eb/destination-utils");

var _Button = _interopRequireDefault(require("eventbrite_design_system/button/Button"));

var _Modal = _interopRequireDefault(require("eventbrite_design_system/modal/Modal"));

var _constants = require("../constants");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var setFollowOrganizerOptInCookieTo = function setFollowOrganizerOptInCookieTo(isOptedIn) {
  _cookiesJs.default.set(_constants.NOTIFICATION_COOKIE, isOptedIn, {
    path: '/',
    secure: true,
    expires: _constants.NOTIFICATION_COOKIE_EXPIRATION_SECONDS
  });
};

var setFollowOrganizerPreference = function setFollowOrganizerPreference(userId, isOptedIn, launchCommSettingsFollowAction) {
  (0, _destinationUtils.setFollowOrganizerStatus)(userId, isOptedIn, launchCommSettingsFollowAction).catch(function (err) {
    (0, _logger.warn)('Follow Organizer: Setting Follow Organizer Preferences Error', {
      userId: userId,
      isOptedIn: isOptedIn,
      err: err
    });
  });
};

var TitleHeader = function TitleHeader(_ref) {
  var title = _ref.title;
  var component = null;

  if (title) {
    component = /*#__PURE__*/_react.default.createElement("h2", {
      className: " eds-dialog__title eds-l-mar-top-10 eds-l-pad-hor-5 eds-align--center eds-text--center eds-text-hs eds-text-weight--heavy",
      "data-spec": "eds-dialog__title"
    }, title);
  }

  return component;
};

var MessageParagraph = function MessageParagraph(_ref2) {
  var message = _ref2.message;
  var component = null;

  if (message) {
    component = /*#__PURE__*/_react.default.createElement("p", {
      className: " eds-dialog__message eds-l-mar-vert-5 eds-text-bm eds-text--center eds-text-color--ui-800 eds-l-pad-hor-10 "
    }, message);
  }

  return component;
};

var ButtonBar = /*#__PURE__*/function (_Component) {
  _inherits(ButtonBar, _Component);

  var _super = _createSuper(ButtonBar);

  function ButtonBar() {
    var _this;

    _classCallCheck(this, ButtonBar);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "_createRef", function (name) {
      return function (ref) {
        _this[name] = ref;
      };
    });

    _defineProperty(_assertThisInitialized(_this), "_focusRef", function (ref) {
      if (ref) {
        ref.focus();
      }
    });

    return _this;
  }

  _createClass(ButtonBar, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this._focusRef(this.okButtonRef);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          primaryType = _this$props.primaryType,
          primaryText = _this$props.primaryText,
          onPrimaryAction = _this$props.onPrimaryAction,
          secondaryType = _this$props.secondaryType,
          secondaryText = _this$props.secondaryText,
          onSecondaryAction = _this$props.onSecondaryAction,
          title = _this$props.title;
      var buttonBarClasses = (0, _classnames.default)('eds-dialog__button-bar', 'eds-align--center', 'eds-text-bm', {
        'eds-dialog__button-bar--with-title': title
      });
      var secondaryButton = null;

      if (secondaryText) {
        secondaryButton = /*#__PURE__*/_react.default.createElement("div", {
          className: "eds-dialog__secondary-button eds-l-pad-hor-2"
        }, /*#__PURE__*/_react.default.createElement(_Button.default, {
          onClick: onSecondaryAction,
          style: secondaryType,
          "data-spec": "eds-dialog__secondary-button"
        }, secondaryText));
      }

      var component = null;

      if (primaryText) {
        component = /*#__PURE__*/_react.default.createElement("div", {
          className: "eds-l-mar-top-5 eds-l-mar-bot-10"
        }, /*#__PURE__*/_react.default.createElement("div", {
          className: "eds-dialog__button-bar eds-align--center"
        }, /*#__PURE__*/_react.default.createElement("div", {
          className: buttonBarClasses
        }, secondaryButton, /*#__PURE__*/_react.default.createElement("div", {
          className: "eds-dialog__primary-button eds-l-pad-hor-2"
        }, /*#__PURE__*/_react.default.createElement(_Button.default, {
          onClick: onPrimaryAction,
          style: primaryType,
          "data-spec": "gdpr-dialog__primary-button",
          ref: this._createRef('okButtonRef')
        }, primaryText)))));
      }

      return component;
    }
  }]);

  return ButtonBar;
}(_react.Component);

var FollowGDPRModal = /*#__PURE__*/function (_Component2) {
  _inherits(FollowGDPRModal, _Component2);

  var _super2 = _createSuper(FollowGDPRModal);

  function FollowGDPRModal(props) {
    var _this2;

    _classCallCheck(this, FollowGDPRModal);

    _this2 = _super2.call(this, props);
    _this2.state = {
      isShown: props.isGDPRModalShown
    };
    return _this2;
  }

  _createClass(FollowGDPRModal, [{
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(props) {
      this.setState({
        isShown: props.isGDPRModalShown
      });
    }
  }, {
    key: "_handleAccept",
    value: function _handleAccept() {
      var _this$props2 = this.props,
          trackGAEvent = _this$props2.trackGAEvent,
          gaCategory = _this$props2.gaCategory,
          userId = _this$props2.userId,
          onCloseGDPRModal = _this$props2.onCloseGDPRModal,
          launchCommSettingsFollowAction = _this$props2.launchCommSettingsFollowAction;
      trackGAEvent({
        action: _constants.GDPR_ACCEPT_GA_ACTION,
        category: gaCategory
      });
      setFollowOrganizerPreference(userId, true, launchCommSettingsFollowAction);
      setFollowOrganizerOptInCookieTo(true);
      onCloseGDPRModal();
    }
  }, {
    key: "_handleReject",
    value: function _handleReject() {
      var _this$props3 = this.props,
          trackGAEvent = _this$props3.trackGAEvent,
          gaCategory = _this$props3.gaCategory,
          userId = _this$props3.userId,
          onCloseGDPRModal = _this$props3.onCloseGDPRModal,
          launchCommSettingsFollowAction = _this$props3.launchCommSettingsFollowAction;
      trackGAEvent({
        action: _constants.GDPR_REJECT_GA_ACTION,
        category: gaCategory
      });
      setFollowOrganizerPreference(userId, false, launchCommSettingsFollowAction);
      setFollowOrganizerOptInCookieTo(false);
      onCloseGDPRModal();
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react.default.createElement(_Modal.default, {
        type: "simple",
        isShown: this.state.isShown,
        onClose: this._handleReject.bind(this),
        noMinHeight: true
      }, /*#__PURE__*/_react.default.createElement(TitleHeader, {
        title: _constants.GDPR_TITLE_TEXT
      }), /*#__PURE__*/_react.default.createElement(MessageParagraph, {
        message: _constants.GDPR_SUBTITLE_TEXT
      }), /*#__PURE__*/_react.default.createElement(ButtonBar, {
        onPrimaryAction: this._handleAccept.bind(this),
        primaryText: _constants.ACCEPT_TEXT,
        primaryType: "link",
        onSecondaryAction: this._handleReject.bind(this),
        secondaryText: _constants.REJECT_TEXT,
        secondaryType: "link"
      }));
    }
  }]);

  return FollowGDPRModal;
}(_react.Component);

_defineProperty(FollowGDPRModal, "propTypes", {
  userId: _propTypes.default.string.isRequired,
  isGDPRModalShown: _propTypes.default.bool.isRequired,
  onCloseGDPRModal: _propTypes.default.func.isRequired,
  trackGAEvent: _propTypes.default.func.isRequired,
  gaCategory: _propTypes.default.string.isRequired,
  launchCommSettingsFollowAction: _propTypes.default.bool
});

var _default = (0, _withFollowGDPRModalControls.default)(FollowGDPRModal);

exports.default = _default;
//# sourceMappingURL=FollowGDPRModal.js.map